var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNoTime = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 102,
    fill: "none",
    viewBox: "0 0 105 102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FABB81",
    d: "M1 20.065c0-5.523 4.477-10 10-10h79.453c5.523 0 10 4.477 10 10v12.403H1V20.065z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 32H100V92H2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4813F",
    d: "M50.727 93.541c.552 0 1-.448 1-1s-.448-1-1-1v2zm48.726-42.238c0 .552.448 1 1 1s1-.448 1-1h-2zM11 11.065h79.453v-2H11v2zM2 82.54V20.065H0V82.54h2zm48.727 9H11v2h39.727v-2zm48.726-71.476v31.238h2V20.065h-2zM0 82.54c0 6.075 4.925 11 11 11v-2c-4.97 0-9-4.03-9-9H0zm90.453-71.476c4.97 0 9 4.03 9 9h2c0-6.075-4.925-11-11-11v2zM11 9.065c-6.075 0-11 4.925-11 11h2c0-4.97 4.03-9 9-9v-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.44,
    height: 20.791,
    x: 19.656,
    y: 1,
    fill: "#fff",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4.72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.44,
    height: 20.791,
    x: 46.007,
    y: 1,
    fill: "#fff",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.44,
    height: 20.791,
    x: 72.357,
    y: 1,
    fill: "#fff",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4813F",
    strokeWidth: 2,
    d: "M1 31.468L100.453 31.468"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 15.261,
    y: 42.975,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 35.151,
    y: 42.975,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 55.041,
    y: 42.975,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 74.932,
    y: 42.975,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 15.261,
    y: 58.1,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 35.151,
    y: 58.1,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 55.041,
    y: 58.1,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 15.261,
    y: 73.018,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.188,
    x: 35.151,
    y: 73.018,
    fill: "#FEEBD2",
    stroke: "#F4813F",
    strokeWidth: 2,
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.391,
    cy: 79.281,
    r: 21.719,
    fill: "#fff",
    stroke: "#F4813F",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4813F",
    fillRule: "evenodd",
    d: "M83.601 79.28l6.708-6.708c.611-.61.611-1.598 0-2.21-.61-.61-1.598-.61-2.21 0l-6.707 6.71-6.709-6.71c-.61-.61-1.598-.61-2.209 0-.611.612-.611 1.6 0 2.21l6.708 6.709-6.708 6.708c-.611.61-.611 1.598 0 2.21.305.304.705.457 1.105.457s.8-.153 1.105-.458l6.708-6.708 6.708 6.708c.305.305.705.458 1.105.458s.8-.153 1.104-.458c.611-.61.611-1.598 0-2.21l-6.708-6.707z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no_time.3a68502e.svg";
export { ForwardRef as ReactComponent };